import React from 'react';
import menuLinkClickStatsigTrack from 'src/functions/menuClickLinkStatsigTrack';
import { useExpandedMenuController } from 'src/hooks/useExpandedMenuController';
import Button from 'atoms/Button/Button';
import { IMenuLink } from 'src/app/molecules/Header/Header/HeaderLinks';
import { cssVar } from 'src/app/styles/helper';
import { ChevronIcon, SideNavLinkContainer } from './SideNavLink.styles';

interface SideNavLinkProps extends IMenuLink {
  locationPathname: string;
}

const SideNavLink = (props: SideNavLinkProps): JSX.Element => {
  const { text, href, trackingSlug, locationPathname } = props;
  const { currentExpanded, toggleExpandedMenu } = useExpandedMenuController();

  const expandableMenuOpen = currentExpanded === text;
  const isActivePath = locationPathname === href;

  const trackLinkOnCLick = () => {
    menuLinkClickStatsigTrack(trackingSlug);
    return true; // To proceed with anchor link event
  };

  const onExpandableMenuToggle = () => {
    if (!expandableMenuOpen) {
      // Track only opening the expandable menu
      trackLinkOnCLick();
    }

    toggleExpandedMenu(props.text);
  };

  const onExpandableMenuClose = () => {
    toggleExpandedMenu(props.text, false);
  };

  if (props.useExpandableMenu && props.expandableMenu) {
    return (
      <SideNavLinkContainer
        direction='column'
        align='flex-start'
        justify='flex-start'
      >
        <Button
          size='lg'
          variant='tertiary'
          iconPosition='right'
          className={`sidenav-menu-link ${isActivePath ? 'active' : ''} ${expandableMenuOpen ? 'expanded' : ''}`}
          onClick={onExpandableMenuToggle}
          icon={
            <ChevronIcon
              width={20}
              orientation={expandableMenuOpen ? 'up' : 'down'}
              color={cssVar('fg-quaternary')}
            />
          }
        >
          {text}
        </Button>
        <props.expandableMenu
          onClose={onExpandableMenuClose}
          isOpen={expandableMenuOpen}
        />
      </SideNavLinkContainer>
    );
  }

  return (
    <SideNavLinkContainer
      direction='column'
      align='flex-start'
      justify='flex-start'
    >
      <Button
        variant='tertiary'
        href={href}
        size='lg'
        className={`sidenav-menu-link ${isActivePath ? 'active' : ''}`}
        onClick={trackLinkOnCLick}
      >
        {text}
      </Button>
    </SideNavLinkContainer>
  );
};

export default SideNavLink;
